import React, {useEffect, useState} from "react";
import {getTaskLinks, getTaskLinksHost} from 'api';
import {Button, Form, Input, Table, Row, Col, Modal} from "antd";
import {confirmAlert} from "react-confirm-alert";
import AddEditLinkDialog from "../TaskLinks/AddEditLinkDialog";
import {Link} from "react-router-dom";
import {isAdministrator} from "../../../utils/UserInfo";
import {
    commonFilter,
    //SearchAndDropdownComponent,
    //commonFilter,
    commonSorter, composeFilters, SearchAndDropdownComponent, searchAndDropDownFilters, searchAndDropDownOnFilters,
    //composeFilters,
    //searchAndDropDownFilters,
    //searchAndDropDownOnFilters,
} from 'utils/AntdTableFunctions';

function TaskLinksView(props){

    const [links,setLinks] = useState([]);
    const [linkHost, setLinkHost] = useState(null);

    useEffect(() => {
        async function getData() {
            let links = await getTaskLinks();
            setLinks(links.data);
            let host = await getTaskLinksHost();
            setLinkHost(host);
        }
        getData();
    }, []);

    function EditCellFormatter(cell, row)
    {
        if(isAdministrator())
            return (<Link to={`#`} onClick={() => openEditDialog(row)}><strong>{row.linkId}</strong></Link>);
        else
            return (<>{row.linkTitle}</>);
    }
    function UpdatedFormatter(cell, row)
    {
        return (
            <div>{row.lastModifiedUser}{' '}{row.lastModifiedDate}</div>
        );
    }
    function CreatedFormatter(cell, row)
    {
        return (
            <div>{row.createdUser}{' '}{row.createdDate}</div>
        );
    }
    function openEditDialog(row)
    {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <AddEditLinkDialog action={'Edit'} link={row} onClose={onClose} setLinks={setLinks}/>
                );
            }
        });
    }
    function OpenAddNewLinkDialog()
    {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <AddEditLinkDialog action={'Add'} link={null} onClose={onClose} setLinks={setLinks}/>
                );
            }
        });
    }
    function linkCellFormatter(cell, row)
    {
        return (
            <a href={row.link.slice(0,4)==='http' ? row.link : linkHost+row.link} target='_blank'>{row.linkTitle}</a>
        );
    }

    const LinksColumns = [
        {
            title: 'ID',
            dataIndex: 'linkId',
            key: 'linkId',
            width: '5%',
            hidden: !isAdministrator(),
            render: EditCellFormatter,
            sorter: (a,b) => commonSorter(a,b,'linkId')
        },
        {
            title: 'Link Title',
            dataIndex: 'linkTitle',
            key: 'linkTitle',
            width: '30%',
            render: linkCellFormatter,
            sorter: (a,b) => commonSorter(a,b,'linkTitle'),
            filters: searchAndDropDownFilters('linkTitle', links),
            ...SearchAndDropdownComponent(),
            onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'linkTitle'),
        },
        {
            title: 'Link',
            dataIndex: 'link',
            width: '20%',
            key: 'link',
            sorter: (a,b) => commonSorter(a,b,'link'),
            filters: searchAndDropDownFilters('link', links),
            ...SearchAndDropdownComponent(),
            onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'link'),
        },
        {
            title: 'Document ID',
            dataIndex: 'docId',
            key: 'docId',
            sorter: (a,b) => commonSorter(a,b,'docId'),
            filters: searchAndDropDownFilters('docId', links),
            ...SearchAndDropdownComponent(),
            onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'docId'),
        },
        {
            title: 'Disable?',
            dataIndex: 'disableFlag',
            key: 'disableFlag',
            width: '5%',
            sorter: (a,b) => commonSorter(a,b,'disableFlag')
        },
        {
            title: 'Created By',
            dataIndex: 'createdUser',
            key: 'createdUser',
            render: CreatedFormatter
        },
        {
            title: 'Modified By',
            dataIndex: 'lastModifiedUser',
            key: 'lastModifiedUser',
            render: UpdatedFormatter
        }
    ];

    return (
        <div>
            <div>
                <Row>
                    <Col>
                        {isAdministrator() &&
                        <Button
                            type='primary'
                            style={{alignItems: 'end', alignContent: 'end'}}
                            onClick={() => OpenAddNewLinkDialog()}
                        >
                            Add New Link
                        </Button>
                        }
                    </Col>
                </Row>
            </div>
            <Table
                bordered
                dataSource={links}
                columns={LinksColumns.filter(t=>!t.hidden)}
                pagination={false}
                //pagination={{ showSizeChanger: false, pageSize: 10 }}
                scroll={{ y: true }}
                style={{ paddingTop: '15px', paddingBottom: '15px' }}
            />
        </div>
    )
}
export default TaskLinksView;